export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// 4~10 個英數字（至少各一）
export const PASSWORD_REGEXP = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{4,10}$/;